<template>
    <div class="form-group">
       <label>{{ lng.citizenship}}</label>
        <select v-model="dataRequest.citizenship"
              @change="sendRequest">
              <option v-for="item in countries"
                         :value="item.id" v-text="item.name"
                  ></option>
         </select>
    </div>


</template>

<script>
import {mapActions, mapGetters} from 'vuex';


export default {
   computed: {
        ...mapGetters([
        'lng', 'countries', 'dataRequest'])
   },
   methods: {
   ...mapActions([
      'prepareRequest',
       'sendRequest'
      ])
   }
}
</script>


<style lang="sass"></style>


// WEBPACK FOOTER //
// Countries.vue?6bf294d3